// extracted by mini-css-extract-plugin
export default {"Cancel":"globalButtonStylng_Cancel__X86-t","Basic":"globalButtonStylng_Basic__6d557","Submit":"globalButtonStylng_Submit__Q+ABX"};